import { render } from "./Logo.vue?vue&type=template&id=02530a38&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=02530a38&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02530a38"]])

export default __exports__